export const Constants = {
  dataEntrance: 'Entrada de Dados',
  dataEdition: 'Edição de Dados',
  cancelOs: 'cancelar OS',
  cancelOsText: 'cancelar esta OS',
  reportData: 'Dados do relatório',
  propertyData: 'Dados do imóvel',
  uploadText: 'Faça o upload ou download dos seguintes documentos:',
  propertyRegister: 'Matrícula do imóvel',
  upload: 'upload',
  iptu: 'Cartela do IPTU',
  downloadText:
    'Você pode realizar o download dos seguintes documentos anexados:',
  download: 'download',
  propertyAddress: 'Localização do imóvel',
  searchMap: 'pesquisar no mapa',
  mapUpdated: 'mapa atualizado',
  fieldsIncomplete: 'Preencha os campos obrigatórios do endereço',
  lat: 'Latitude: ',
  lng: 'Longitude:',
  movePin: 'Mova o pin caso a localização esteja incorreta',
  propertyDetails: 'Características do imóvel',
  submit: 'criar nova os',
  confirmEdit: 'confirmar alterações',
  approve: 'aprovar',
  cancel: 'cancelar',
  pept: 'enviar para PEPT',
  changeStatus:
    'Você gostaria de gravar os dados atuais e alterar o status da OS ** de Entrada para Proposta?',
  removeRequest:
    'excluir essa atribuição para a OS ficar disponível para uma nova atribuição',
  remove: 'refazer atribuição de OS',
  scheduleResponsibleData: 'Informações sobre agendamento',
  yes: 'Sim',
  no: 'Não',
  confirmationAlert: ' Atenção! Esta ação não poderá ser desfeita.',
};
